module.exports = __webpack_public_path__ + "static/media/482526_587028704654690_37329049_n.cf95f8cd.jpg";